<div class="clock">
  <span class="hour">{{ hours }}</span>
  <span [className]="blink ? 'hid' : 'sho'">:</span>
  <span class="min">{{ minutes }}</span>
  <!--<span class="second">{{ seconds }}</span>-->
</div>
